<div class="reset-password-page">
    <div class="reset-password-container">
        <div class="reset-password-dialog">
            <div class="logoholder">
                <img src="../../images/BB-Link-logo.svg" class="img-responsive" />
            </div>
            <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                <h2>Reset password</h2>

                @if (isSuccess()) {

                <div class="reset-password-dialog__icon">
                    <svg viewBox="0 0 64 64" width="120" height="120">
                        <circle cx="32" cy="32" r="28" fill="#e8f5e9" stroke="#4caf50" stroke-width="2" />
                        <path d="M 20 32 L 28 40 L 44 24" fill="none" stroke="#4caf50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="reset-password-dialog__note">
                    <p>Your password has been reset successfully.</p>
                    <p>You will be redirected to the <a href="/login">login page</a> shortly.</p>
                </div>
                }
                @else {
                <app-password decorator caption="New password" section="reset-password" [allowShowPassword]="true" formControlName="newPassword"></app-password>

                <div class="reset-password-dialog__actions">
                    <app-button secondary width="100%" [disabled]="isSubmitting()" (buttonClick)="onCancel()">Cancel</app-button>
                    <app-button primary submit width="100%" [disabled]="resetPasswordForm.invalid || isSubmitting()" type="submit">
                        @if (isSubmitting()) {
                        <span><img src="../../images/ajax-loader.gif" /> Resetting...</span>
                        }
                        @else {
                        <span>Reset password</span>
                        }
                    </app-button>
                </div>
                }
            </form>
        </div>
    </div>
</div>
